import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getServiceWrapper } from 'core/service-wrapper'
import {
  editBasicPremiumState,
  editRiderSelectedPlan,
  editRiderSumAssured,
  editSumAssured,
  editTotalPremium,
  toggleRider,
} from 'quick-quote/product-common/coverage-plan/actions'
import {
  getAvailableRiderCodes,
  getBasicPremium$,
  getBasicPremiumState,
  getSumAssured$,
  getTotalPremium$,
  getReadOnlyFields,
  haveBasicPremiumState,
} from 'quick-quote/product-common/coverage-plan/selectors'
import {
  getSelectedModelFactorID,
  getIHealthyUltraBasicPlanErrorMessage,
} from 'quick-quote/product-ihealthy-ultra/coverage-plan/selectors'
import { getModelFactorsForUser } from 'quick-quote/selectors/model-factors'
import { hasProductSelected } from 'quick-quote/selectors/selected-display-product'

import { selectModelFactor, updateSelectedBasicPlan, validateBasicPlan } from './actions'
import { CoveragePlan } from './components'

const mapStateToProps = (state) => {
  const serviceWrapper = getServiceWrapper()
  return {
    modelFactors: getModelFactorsForUser(state),
    selectedModelFactorID: getSelectedModelFactorID(state),
    basicPremiumState: getBasicPremiumState(state),
    haveBasicPremiumState: haveBasicPremiumState(state),
    sumAssured$: getSumAssured$(state),
    basicPremium$: getBasicPremium$(state),
    readOnlyFields: getReadOnlyFields(state),
    riderCodes: getAvailableRiderCodes(state),
    selectedBasicPlanCode: serviceWrapper.products.I_HEALTHY_ULTRA.getSelectedDisplayProductCodeIHealthyUltra(state),
    totalPremium$: getTotalPremium$(state),
    hasProductSelected: hasProductSelected(state),
    basicPlanOptions: serviceWrapper.products.I_HEALTHY_ULTRA.getBasicPlanOptions(state),
    basicPlanValidationError: getIHealthyUltraBasicPlanErrorMessage(state),
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectModelFactor: bindActionCreators(selectModelFactor, dispatch),
  toggleRider: bindActionCreators(toggleRider, dispatch),
  updateSelectedBasicPlan: bindActionCreators(updateSelectedBasicPlan, dispatch),
  editRiderSumAssured: bindActionCreators(editRiderSumAssured, dispatch),
  editRiderSelectedPlan: bindActionCreators(editRiderSelectedPlan, dispatch),
  editSumAssured: bindActionCreators(editSumAssured, dispatch),
  editBasicPremium: bindActionCreators(editBasicPremiumState, dispatch),
  editTotalPremium: bindActionCreators(editTotalPremium, dispatch),
  validateBasicPlan: bindActionCreators(validateBasicPlan, dispatch),
})

export const CoveragePlanContainer = connect(mapStateToProps, mapDispatchToProps)(CoveragePlan)
